// extracted by mini-css-extract-plugin
export default {"subscriptionCards":"subscriptionCards_subscriptionCards__vUqa1"};